import {LegalEntity} from "./legal-entity";

export class CompanyClientLegalEntity {
  id: number;
  active: boolean;
  legal_entity = new LegalEntity();
}
